import { useState } from "react";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";

const Unconfirmed = () => {
  const { auth } = useAuth();
  const [status, setStatus] = useState("");

  const resend = async () => {
    setStatus("sending");
    try {
      await axios.post("/confirmation", { email: auth?.user });
      setStatus("sent");
    } catch (error) {
      setStatus(error?.response?.status === 429 ? "limited" : "error");
    }
  };

  return (
    <section className="container">
      <h1>Πρέπει πρώτα να επιβεβαιώσετε το email σας.</h1>
      <br />
      <p>Παρακαλώ ελέγξτε και στον φάκελο των spam.</p>
      <button
        type="button"
        className="submit"
        onClick={resend}
        disabled={!auth?.user || status === "sending"}
      >
        {status === "sending" ? "Αποστολή…" : "Επαναποστολή email"}
      </button>
      {status === "sent" && <p>Αν ο λογαριασμός αναμένει επιβεβαίωση, εστάλη νέο email.</p>}
      {status === "limited" && <p className="errmsg">Δοκιμάστε ξανά αργότερα.</p>}
      {status === "error" && <p className="errmsg">Η αποστολή δεν ολοκληρώθηκε.</p>}
    </section>
  );
};

export default Unconfirmed;
